import { enumPanelRenderMode } from "../constants";
import { QSubChartEnable } from "./QSubChartEnable";

export function SubChartOptionEnable(theWSMgr, ribbonGroup, targetBox) {
  var e = new QSubChartEnable();

  var theDoc = theWSMgr.GetDoc();

  var normalMode = theWSMgr.GetViewMode() == enumPanelRenderMode.all;
  var enableIt = theDoc != null && normalMode;
  var enableInsert = false;
  var enableRemove = false;
  // var enableRemoveAll = enableIt;
  if (enableIt) {
    var selection;
    if (targetBox) selection = targetBox;
    else if (ribbonGroup) selection = ribbonGroup.Query("FirstSelBox");
    else selection = theWSMgr.GetFirstSelectedBox(true);
    if (selection && (targetBox || theWSMgr.GetNumSelectedElements() == 1)) {
      if (selection.TopOfSubChartBreak()) {
        enableRemove = true;
      } else if (!selection.BottomOfSubChartBreak(false)) {
        if (selection.GetNumChildren() > 0) {
          var theDoc = theWSMgr.GetDoc();
          var dbObj = selection.GetDataObj();
          enableInsert = theDoc.IsInMainSubChart(dbObj) && dbObj.GetParent() != null;
        }
      }
    }
  }

  e.fEnableInsertBreak = enableInsert;
  e.fEnableRemoveBreak = enableRemove;
  e.fEnableSCWiz = enableIt;

  return e;
}
